import React, { useEffect } from "react";
import funnel from "../../styles/Funnel.module.css";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import { NumericFormat } from "react-number-format";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

const CssTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "var(--primary-color)",
    },
    "&.Mui-focused fieldset": {
      borderColor: "var(--primary-color)",
    },
  },
});

function BuyingChanceDeposit({
  formData,
  setFormData,
  errord,
  setErrord,
  errordn,
  setErrordn,
}) {
  const handleChange = (event) => {
    setFormData({
      ...formData,
      price_deposit: event.target.value,
    });
    setErrord(false);
    setErrordn(false);
  };

  let error;
  let helperText = "Deposit value must be larger than $20,000.";
  if (errord == true) {
    error = "error";
    helperText = "Deposit value cannot be empty!";
  } else if (errordn == true) {
    error = "error";
    helperText = "Deposit value must be larger than $20,000.";
  } else {
    error = "";
    helperText = "Deposit value must be larger than $20,000.";
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <div className={funnel.boxQn}>
        <h2 className={funnel.h2Text}>How much deposite do you have?</h2>
        <FormControl fullWidth>
          <NumericFormat
            error={error}
            helperText={helperText}
            value={formData.price_deposit}
            name="price_deposit"
            placeholder="example: 20000"
            onChange={handleChange}
            id="outlined-adornment-amount"
            thousandSeparator=","
            customInput={CssTextField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
        </FormControl>
      </div>
    </Box>
  );
}

export default BuyingChanceDeposit;
